import React, { useState } from 'react'
import { objectToOptions, arrayToOptions } from 'Utilities/selectOptions'
import { uniqBy, map, flatten } from 'lodash'

import { filteredVMData } from '../Data'
import { defaultOperatingSystemFilters } from '../Filters'
import OperatingSystemSummary from './Summary'
import SoftwareReportContext from '../SoftwareReportContext'

const CloudCoreSoftwareOperatingSystemsReport = ({ operating_systems }) => {
  const [filters, changeFilters] = useState(defaultOperatingSystemFilters)
  const toggleSummary = (showSummary = true, currentView) => changeFilters({ ...filters, showSummary })
  const showNonSummarisedData = (filter, chosenOption) => changeFilters({ filters: { ...filters, [filter]: [chosenOption] } })
  const filterOptions = {
    customers: uniqBy(map(operating_systems, vm => ({ value: vm.viaje_client_id, label: vm.customer_name })), 'label'),
    locations: uniqBy(map(operating_systems, vm => ({ value: vm.location_id, label: vm.location_name })), 'label'),
    operating_systems: objectToOptions(operating_systems, 'operating_system'),
    functions: objectToOptions(map(operating_systems, 'cluster'), 'function'),
    ownerships: objectToOptions(map(operating_systems, 'cluster'), 'ownership'),
    machine_type_sources: objectToOptions(operating_systems, 'machine_type_source'),
    vendors: objectToOptions(operating_systems, 'vendor'),
    editions: objectToOptions(operating_systems, 'operating_system_edition'),
    regions: [...arrayToOptions(map(operating_systems, 'region_name')), { label: 'No region', value: null }]
  }

  return (
    <SoftwareReportContext.Provider value={{ filterOptions, filters, changeFilters, showNonSummarisedData, toggleSummary }}>
      <OperatingSystemSummary data={flatten(filteredVMData({ vms: operating_systems, filters }))} />
    </SoftwareReportContext.Provider>
  )
}

export default CloudCoreSoftwareOperatingSystemsReport
